/**
 * ============================================================
 * JDL — Taille non présélectionnée (21/10/2026)
 * ------------------------------------------------------------
 * Dawn coche la première taille disponible (souvent XS). Risque : un client
 * pressé commande un XS sans s'en rendre compte → réimpression POD à nos frais.
 *
 * Ce module, à l'arrivée sur une fiche vêtement :
 *   - décoche les boutons de taille ;
 *   - désactive « Ajouter au panier » avec le libellé « Choisir votre taille » ;
 *   - grise les paiements express (PayPal…) qui achèteraient sinon la taille par défaut.
 * Dès que le client choisit une taille, Dawn reprend la main normalement.
 *
 * Ne s'applique PAS (décidé côté Liquid, product-variant-picker.liquid) :
 *   - aux produits sans option « Taille » (affiches, mugs, carte cadeau) ;
 *   - aux produits dont le prix varie selon la variante ;
 *   - au sélecteur en liste déroulante (le site utilise des boutons).
 * Ne s'applique pas non plus si l'URL contient ?variant= (pubs catalogue
 * Meta / Google / Pinterest) : la taille de l'URL est conservée.
 *
 * RGPD : aucune donnée collectée ni stockée, aucun cookie.
 * ============================================================
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api; // tests Node
  else api.boot(window, document);
})(this, function () {
  'use strict';

  var PENDING = 'pending'; // taille à choisir
  var CHOSEN = 'chosen'; // le client a choisi
  var OFF = 'off'; // module inactif sur ce produit
  var PENDING_CLASS = 'jdl-size-pending';

  /**
   * État initial d'un bloc produit. Fonction pure (testée).
   * @param {Object} p
   * @param {boolean} p.enabled        produit éligible (attribut posé par Liquid)
   * @param {boolean} p.isMainProduct  fiche principale (pas une fenêtre « Choisir des options »)
   * @param {boolean} p.urlHasVariant  l'URL de la page contient ?variant=
   * @returns {'pending'|'off'}
   */
  function initialState(p) {
    if (!p.enabled) return OFF;
    if (p.isMainProduct && p.urlHasVariant) return OFF; // lien direct vers une taille : on respecte
    return PENDING;
  }

  /** Le libellé est fourni par Liquid ; repli si absent. */
  function labelOf(variantSelects) {
    return (variantSelects && variantSelects.getAttribute('data-jdl-size-label')) || 'Choisir votre taille';
  }

  /** Remet le bloc en attente de taille (appelé au chargement et après chaque re-rendu Dawn). */
  function applyPending(productInfo) {
    var vs = productInfo.querySelector('variant-selects[data-jdl-require-size="true"]');
    var sizeBox = vs && vs.querySelector('[data-jdl-size-option]');
    if (!sizeBox) return;

    sizeBox.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.checked = false;
    });
    productInfo.classList.add(PENDING_CLASS);

    var form = productInfo.querySelector('product-form');
    if (form && typeof form.toggleSubmitButton === 'function') {
      form.toggleSubmitButton(true, labelOf(vs));
    }
  }

  /** Initialise un bloc produit s'il ne l'a pas déjà été. */
  function setup(productInfo, win) {
    if (productInfo.dataset.jdlSizeState) return;
    var vs = productInfo.querySelector('variant-selects');
    var state = initialState({
      enabled: !!(vs && vs.getAttribute('data-jdl-require-size') === 'true'),
      // Les fenêtres d'options (quick-add) portent data-update-url="false"
      isMainProduct: productInfo.dataset.updateUrl !== 'false',
      urlHasVariant: new win.URLSearchParams(win.location.search).has('variant'),
    });
    productInfo.dataset.jdlSizeState = state;
    if (state === PENDING) applyPending(productInfo);
  }

  function boot(win, doc) {
    if (win.__jdlSizeRequired) return; // le snippet peut être rendu plusieurs fois
    win.__jdlSizeRequired = true;

    function setupAll() {
      doc.querySelectorAll('product-info').forEach(function (el) {
        setup(el, win);
      });
    }

    // 1. Fiche produit au chargement
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', setupAll);
    else setupAll();

    // 2. Fenêtres « Choisir des options » chargées plus tard (carrousel cross-sell)
    doc.addEventListener('product-info:loaded', function (e) {
      if (e.target && e.target.tagName === 'PRODUCT-INFO') setup(e.target, win);
    });

    // 3. Le client choisit une taille : on rend la main à Dawn (capture = avant Dawn)
    doc.addEventListener(
      'change',
      function (e) {
        if (!e.target.closest || !e.target.closest('[data-jdl-size-option]')) return;
        var pi = e.target.closest('product-info');
        if (!pi || pi.dataset.jdlSizeState !== PENDING) return;
        pi.dataset.jdlSizeState = CHOSEN;
        pi.classList.remove(PENDING_CLASS);
      },
      true
    );

    // 4. Changement de couleur sans taille choisie : Dawn re-coche une taille → on la décoche.
    // PUB_SUB_EVENTS est un `const` global de Dawn (constants.js) : pas une propriété de window.
    if (typeof win.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      win.subscribe(PUB_SUB_EVENTS.variantChange, function () {
        doc.querySelectorAll('product-info[data-jdl-size-state="' + PENDING + '"]').forEach(applyPending);
      });
    }
  }

  return { initialState: initialState, labelOf: labelOf, boot: boot, PENDING: PENDING, OFF: OFF, CHOSEN: CHOSEN };
});
